import { gql } from "@apollo/client";

export const GET_WORKER_FOR_REVIEW_QUERY = gql`
  query GetWorkerForReview($token: String!) {
    getWorkerForReview(token: $token) {
      name
      role
      startedAt
      location
      payRateValue
      payCurrency
      payFrequency
      profileImageUrl
    }
  }
`;

export const SUBMIT_WORKER_REVIEW_MUTATION = gql`
  mutation SubmitWorkerReview($token: String!, $score: Int!, $comment: String) {
    submitWorkerReview(token: $token, score: $score, comment: $comment)
  }
`;
